import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautoexport'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const Export = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/export`, data, config)

const RegulationAutoExportRepository = {
  Export
}

export default RegulationAutoExportRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautoexport.js